import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { buildSchoolYearRange } from "../../components/common/schoolYear";

const settingsReducer = (state = initialState.settings, action) => {
  switch (action.type) {
    case types.TOGGLE_CLIENT_LIST:
      return { ...state, showArchivedClients: !state.showArchivedClients };
    case types.SET_ACTIVE_SCHOOL_YEAR_START_YEAR: {
      if (state.activeSchoolYearStartYear === action.payload) return state;
      const { fromDate, tillDate } = buildSchoolYearRange(action.payload);
      return {
        ...state,
        activeSchoolYearStartYear: action.payload,
        schoolClassesFilters: { ...state.schoolClassesFilters, fromDate, tillDate },
      };
    }
    case types.UPDATE_SCHOOL_CLASSES_FILTERS:
      return { ...state, schoolClassesFilters: action.payload };
    default:
      return state;
  }
};

export default settingsReducer;
